import request from '../utils/Request';
import { Methods } from '../config';
import { downloadFile } from '../utils/download';

const baseURL = 'serviceCore';

const serviceCoreService = {
  getItem: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  getItemsFromView: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data/view`,
      data,
    });
  },

  getWorkAreasFromView: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data/workArea/view`,
      data,
    });
  },

  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  updateServiceWorkArea: (id, workAreaId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/workArea/${encodeURIComponent(id)}/${encodeURIComponent(workAreaId)}`,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  createWorksheet: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/worksheet`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  searchServices: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/search`,
      data,
    });
  },

  getItemById: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  createDocument: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/document`,
      data,
    });
  },

  createReceipt: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/receipt`,
      data,
    });
  },

  getServiceTask: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/task/${encodeURIComponent(id)}`,
    });
  },

  uploadFile: (data, files) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    formData.append('data', JSON.stringify(data));
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task/uploadFile`,
      formData: true,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  checkReceiptItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/checkReceiptItem`,
      data,
    });
  },

  checkAlreadyIssuedItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/checkAlreadyIssuedItem`,
      data,
    });
  },

  printDocument: async (data) => {
    const pdf = await request({
      responseType: 'blob',
      method: Methods.POST,
      resource: `${baseURL}/print`,
      data,
    });

    return downloadFile(pdf, pdf.filename);
  },
};
export default serviceCoreService;
